<template>
  <a :name="name" :class="$style.ctn">
    <slot />
  </a>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    name: { type: String, required: true },
    parent: { type: String, default: null },
  },
});
</script>
<style lang="scss" module>
.ctn {
  display: block;
}
</style>
